import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { TagNodeListComponent, TagService } from '@alfresco/adf-content-services';
import { PaginationModel } from '@alfresco/adf-core';
import { TagEntry } from '@alfresco/js-api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'aca-add-existing-tag-action',
  templateUrl: './add-existing-tag-action.component.html',
  styleUrls: ['./add-existing-tag-action.component.scss']
})
export class AddExistingTagActionComponent implements OnInit, OnDestroy {

  /** The identifier of a node. */
  @Input()
    nodeId!: string;
  /** Emitted when a tag is selected. */
  @Output()
  result = new EventEmitter();

  tagListComponent!: TagNodeListComponent;

  /**
   * Array of tags that are available to add
   */
  tagsEntries: TagEntry[] = [];

  /**Array of tags that have been added to the node */
  tags: TagEntry[] = [];

  /**
   * Number of items per iteration
   */
  size: number = 10;

  defaultPagination: PaginationModel;
  pagination: PaginationModel;

  isLoading = false;
  isSizeMinimum = true;

  private onDestroy$ = new Subject<boolean>();

  constructor(private tagService: TagService) {
      this.defaultPagination = {
          skipCount: 0,
          maxItems: this.size,
          hasMoreItems: false
      };

      this.pagination = this.defaultPagination;

      this.tagService.refresh.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
          this.tagsEntries = [];
          this.refreshTag(this.defaultPagination);
      });
  }

  ngOnInit() {
      this.refreshTag(this.defaultPagination);
  }

  ngOnDestroy() {
      this.onDestroy$.next(true);
      this.onDestroy$.complete();
  }

  refreshTag(opts?: any) {
      this.tagService.getAllTheTags(opts).subscribe((tags) => {

        if(tags && tags.list){
          this.tagsEntries = this.tagsEntries.concat(tags.list.entries);
          this.pagination = tags?.list?.pagination;
          this.result.emit(this.tagsEntries);
          this.isLoading = false;
        }
      });
  }

  loadMoreTags() {
      if (this.pagination.hasMoreItems) {
          this.isLoading = true;
          this.isSizeMinimum = false;

          if(this.pagination && this.pagination.skipCount && this.pagination.count){
            this.refreshTag({
                skipCount: this.pagination.skipCount + this.pagination.count,
                maxItems: this.size
            });
        }
      }
  }

  loadLessTags() {
      this.isSizeMinimum = false;
      if(this.pagination && this.pagination.skipCount && this.pagination.count){
        this.tagsEntries = this.tagsEntries.slice(0, this.tagsEntries.length - this.pagination.count);
        this.pagination.skipCount = this.pagination.skipCount - this.pagination.count;
        this.pagination.hasMoreItems = true;

        if (this.tagsEntries.length <= this.size) {
            this.isSizeMinimum = true;
        }
    }
  }


   addTag(tag: string) {
    //console.log("Tag", tag);

      this.tagService.addTag(this.nodeId, tag).subscribe(() => {
          //this.tagListComponent.refreshTag();
          this.result.emit(this.nodeId);
      });
    }

    setExistingTags(tags: TagEntry[]){
      //console.log(tags);
      this.tags = tags;
    }

    /** check if the tag already exists in the current node */
    existingTag(tag: TagEntry): boolean {

      return this.tags.some(obj => obj.entry.id === tag.entry.id);
    }


}
